import React from 'react';
import ButtonBorderedKVBase from '@/presentation/components/button-bordered-kv/button-bordered-kv';
import { IconArrowBack } from '@/presentation/components/icons';
import Styles from './header-menu-styles.scss';
import ArrowDown from '@/presentation/components/icons/arrow-down';
const HeaderMenu = ({ title1, title2, onBack, onDelete }) => {
    const handleOnBack = () => {
        if (onBack)
            onBack();
    };
    return (React.createElement("div", { className: Styles.wrap },
        React.createElement(ButtonBorderedKVBase, { type: "button", color: 'black', onClick: handleOnBack, leftIcon: React.createElement(IconArrowBack, { color: 'black' }), leftIconClass: Styles.leftIconWrap, btnChildClass: Styles.btnChildBack, btnWrapClass: Styles.btnWrapClass },
            React.createElement("div", null, "Back ")),
        "\u00A0",
        React.createElement("span", { className: Styles.title, style: { color: title2 ? '#00A3FF' : 'inherit' } }, title1),
        title2 && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: Styles.icon },
                React.createElement(ArrowDown, { color: "#999999" })),
            React.createElement("span", { className: Styles.title, style: { color: 'black' } }, title2)))));
};
export default HeaderMenu;
